import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';

const SortIcon = ({ sortObj }) => (
  <>
    {sortObj?.active === 'desc' ? <FontAwesomeIcon icon={faSortDown} /> : ''}
    {sortObj?.active === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : ''}
    {sortObj?.active !== 'asc' && sortObj?.active !== 'desc' ? <FontAwesomeIcon icon={faSort} /> : ''}
  </>
)

SortIcon.defaultProps = {

}

SortIcon.propTypes = {
  sortObj: PropTypes.object,
}

export default SortIcon;
